module.exports = __webpack_public_path__ + "img/calendar-rangeF38235.3554d3e9.svg";